import QuickSearchReducer from './QuickSearchReducer';

export default from './QuickSearchContainer';
export const QuickSearchReducers = {
  QuickSearchReducer,
};
